<p-dialog #attachmentDialog styleClass="no-animation-dialog strategies-confirm-dialog strategies-attachment-dialog"
          [modal]="true" [closable]="false" [positionTop]="20" [minWidth]="750" appendTo="body" [draggable]="false" [resizable]="false">
  <p-header>
    <span auto="upload-header" class="dialog-title attachment-dialog-title"><img class="attachment-header-icon" src="assets/images/attachment-icon-white.svg">Attachments</span>
  </p-header>
  <div>
    <p class="attachment-instructions">
      A file may be attached using three methods. Select a file by using the drag and drop feature, use the select file button to browse and attach files manually, or enter a URL for an external link. File size is limited to 10 MB. Standard document, image, spreadsheet, and presentation files are acceptable. Please do not attach audio or video files.
    </p>
    <div class="attachment-bordered-content">
      <p-tabView #attachmentDialogTabView (onChange)="onTabChange($event)" styleClass="strategies-tab-view">
        <p-tabPanel header="Attach File" [selected]="true">
          <form class="standard-form" [formGroup]="attachFilesForm">
            <label for="fileUpload" class="standard-label"><strong>Attach File* </strong>
              <i *ngIf="isDialogEditAttachement"
                 class="eleot-icon icon-info"
                 tooltipStyleClass="attach-info-tooltip"
                 tooltipPosition="bottom"
                 pTooltip="Attached files cannot be deleted by editing. To remove, use the cancel button below, then select the delete icon."></i>
            </label>
            <div *ngIf="!isDialogEditAttachement" class="input-error-wrap sans-margin">
              <p-fileUpload #fileUpload
                            id="fileUpload"
                            name="file"
                            [ngClass]="{'has-file': hasFile, 'highlight-file-selector': highlightFileSelector}"
                            styleClass="resource-upload"
                            [url]="resourceUploadEvidenceUrl"
                            [showCancelButton]="false"
                            [showUploadButton]="false"
                            (onSelect)="onSelect($event)"
                            (onBeforeUpload)="onBeforeUpload($event)"
                            (onBeforeSend)="onBeforeSend($event)"
                            (onRemove)="onRemove($event)"
                            (onClear)="onClear()"
                            (onUpload)="onUpload($event)"
                            (onError)="onError($event)"
                            chooseLabel="Select File">
                <ng-template pTemplate="content">
                  <div class="standard-label">
                    <div class="drop-target-row" *ngIf="!hasFile">
                      <i class="cloud-icon"></i>
                      <span class="drag-text"><strong>Drag & drop file</strong></span>
                    </div>
                    <div class="ui-fileupload-row"
                         *ngFor="let file of fileUpload.files; let i = index;"
                          [ngClass]="{'has-error': attachmentFile.invalid && attachmentFile.touched}">
                      <div class="upload-row-attach-icon"><img [src]="iconImageSrcForFile(file)"></div>
                      <div class="upload-row-file-name">{{file.name}}</div>
                      <div class="upload-row-file-size">{{fileUpload.formatSize(file.size)}}</div>
                      <div class="upload-row-clear-icon">
                        <button type="button"
                                class="standard-label cancel-file-upload-btn"
                                label="k"
                                pButton
                                (click)="clearSelectedFile($event, i)"></button>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template let-file pTemplate="file">
                </ng-template>
              </p-fileUpload>
              <app-error-msg class="attachment-error" [control]="attachmentFile"
                             [show]="attachmentFile.invalid && attachmentFile.touched">
              </app-error-msg>
            </div>

            <div *ngIf="isDialogEditAttachement" class="ui-fileupload-row">
              <div class="upload-row-attach-icon"><img class="attachment-icon" [src]="iconImageSrc(attachmentSelection)"
                        tooltipStyleClass="strategies-tooltip"
                        [alt]="altText(attachmentSelection)"
                        [pTooltip]="altText(attachmentSelection)"></div>
              <div class="upload-row-file-name already-uploaded"><strong>{{attachmentSelection.resourceOriginalName}}</strong></div>
              <div class="upload-row-file-size already-uploaded"><strong>{{attachmentSelection.resourceSize}}</strong></div>
            </div>

            <label for="attachment-name" class="standard-label"><strong>Attachment Name*</strong></label>
            <div class="input-error-wrap sans-margin">
              <input auto="attachment-name"
                     id="attachment-name"
                     type="text"
                     [ngClass]="{'standard-input': true, 'error-highlight': (attachmentFileName.invalid && attachmentFileName.touched)}"
                     [maxlength]="MAX_NAME_LENGTH"
                     [formControl]="attachmentFileName"
                     pInputText
                     placeholder="Enter a name for this attachment">
              <div class="remaining-msg">Remaining: {{attachmentFileNameRemainingCharacters}}</div>
            </div>

            <label for="attachment-description" class="standard-label"><strong>Description</strong></label>
            <div class="input-error-wrap sans-margin">
              <textarea auto="attachment-description" id="attachment-description" type="text" class="standard-input"
                        [maxlength]="MAX_DESCRIPTION_LENGTH"
                        [formControl]="attachmentFileDescription"
                        [rows]="3" pInputTextarea placeholder="Enter short description for the attachment">
              </textarea>
              <div class="remaining-msg">Remaining: {{attachmentFileDescriptionRemainingCharacters}}</div>
            </div>
          </form>
        </p-tabPanel>
        <p-tabPanel header="External Link">
          <form class="standard-form external-link-form" [formGroup]="externalLinkForm">
            <label for="external-link" class="standard-label"><strong>Link To*</strong></label>
            <div class="input-error-wrap sans-margin">
              <input auto="upload-external-link" id="external-link" type="text"
                     [maxlength]="MAX_LINK_LENGTH"
                     placeholder="Enter the web page address (URL)"
                     [ngClass]="{'standard-input': true, 'error-highlight': (externalLink.invalid && externalLink.touched)}"
                     [formControl]="externalLink"
                     pInputText>
              <div class="remaining-msg">Remaining: {{externalLinkRemainingCharacters}}</div>
              <app-error-msg [control]="externalLink"
                             [show]="externalLink.invalid && externalLink.touched && (externalLink.value && externalLink.value.length > 0)">
              </app-error-msg>
            </div>

            <label for="external-link-name" class="standard-label"><strong>Attachment Name*</strong></label>
            <div class="input-error-wrap sans-margin">
              <input auto="upload-external-link-name" id="external-link-name" type="text"
                     [maxlength]="MAX_NAME_LENGTH"
                     [formControl]="externalLinkName"
                     [ngClass]="{'standard-input': true, 'error-highlight': (externalLinkName.invalid && externalLinkName.touched)}"
                     pInputText placeholder="Enter a name for this attachment">
              <div class="remaining-msg">Remaining: {{externalLinkNameRemainingCharacters}}</div>
            </div>

            <label for="external-link-description" class="standard-label"><strong>Description</strong></label>
            <div class="input-error-wrap sans-margin">
              <textarea auto="upload-external-link-description" id="external-link-description" type="text" class="standard-input"
                        [maxlength]="MAX_DESCRIPTION_LENGTH"
                        [formControl]="externalLinkDescription"
                        [rows]="3" pInputTextarea placeholder="Enter short description for the attachment">
              </textarea>
              <div class="remaining-msg">Remaining: {{externalLinkDescriptionRemainingCharacters}}</div>
            </div>
          </form>
        </p-tabPanel>
      </p-tabView>
      <div class="attachment-actions-divider"></div>
    </div>
  </div>
  <p-footer class="attachment-actions-container">
    <p class="pull-left attachment-required-instruction">* Indicates required field</p>
    <button auto="upload-cancel-btn" class="btn btn-alt" type="button"
            pButton label="Cancel" (click)="attachmentDialog.visible = false">
    </button>
    <button auto="upload-save-btn" class="btn" type="button" [disabled]="isSaveDisabled" pButton label="Save" (click)="onSaveAttachment()">
    </button>
  </p-footer>
</p-dialog>
